module.exports = __webpack_public_path__ + "static/media/axon-logo.8eca368c.png";